var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterNewstory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 0.837219C14.2085 0.837219 16.3667 1.4919 18.2024 2.71849C20.0381 3.94507 21.4689 5.68838 22.3138 7.72812C23.1586 9.76785 23.3797 12.0124 22.949 14.1778C22.5183 16.3432 21.4551 18.3321 19.894 19.8933C18.3328 21.4544 16.3438 22.5176 14.1784 22.9483C12.0131 23.379 9.76859 23.1579 7.72886 22.3131C5.68912 21.4682 3.94574 20.0374 2.71916 18.2017C1.49258 16.366 0.837891 14.2078 0.837891 12C0.837891 9.03945 2.01396 6.20018 4.10739 4.10675C6.20082 2.01332 9.04012 0.837219 12.0007 0.837219V0.837219Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8012 12H7.20117",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.8V7.19998",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterNewstory);
export default __webpack_public_path__ + "static/media/footer_newstory.e7828e0a5b79d53f9ee7ef5c5dcf054d.svg";
export { ForwardRef as ReactComponent };